class WebSocketManager {
  constructor() {
    this.sockets = {}; // Azonosítóhoz tartozó WebSocket példányok
    this.messages = []; // WebSocket üzenetek
  }

  connect(id, url, config = {}) {
    if (this.sockets[id]) {
      console.warn(`Már létezik kapcsolat ezzel az ID-vel: ${id}`);
      return this.sockets[id];
    }

    const socket = new WebSocket(url);

    socket.onopen = () => config.onOpen && config.onOpen();
    socket.onclose = () => config.onClose && config.onClose();
    socket.onmessage = (message) => {
      config.onMessage && config.onMessage(message);
      this.messages.push(message.data); // Üzenet hozzáadása a listához
    };

    this.sockets[id] = socket;
    return socket;
  }


  // WebSocket kapcsolat bezárása
  disconnect(id) {
    if (this.sockets[id]) {
      this.sockets[id].close();
      delete this.sockets[id];
    }
  }

  // Üzenet küldése az adott WebSocket kapcsolaton
  sendMessage(id, message) {
    if (this.sockets[id] && this.sockets[id].readyState === WebSocket.OPEN) {
      this.sockets[id].send(message);
    } else {
      console.error(`Nincs aktív kapcsolat ezzel az ID-vel: ${id}`);
    }
  }

  // Az összes kapcsolat bezárása
  disconnectAll() {
    Object.keys(this.sockets).forEach(id => this.disconnect(id));
  }

  // Üzenetek lekérése
  getMessages() {
    return this.messages;
  }
}

export default WebSocketManager;
